import { List, Datagrid, TextField, DateField, FunctionField, TextInput } from "react-admin";
import { StatusChip } from "../../components/StatusChip";
import { CopyableId } from "../../components/CopyableId";

const filters = [
  <TextInput key="userId" source="userId" label="User ID" alwaysOn />,
  <TextInput key="operatorId" source="operatorId" label="Operator ID" alwaysOn />,
];

export const UserList = () => (
  <List filters={filters} perPage={25}>
    <Datagrid bulkActionButtons={false}>
      <FunctionField label="User ID" render={(r: { userId?: string }) => <CopyableId value={r?.userId} />} />
      <FunctionField label="Operator User ID" render={(r: { operatorUserId?: string }) => <CopyableId value={r?.operatorUserId} />} />
      <FunctionField label="Operator" render={(r: { operatorId?: string }) => <CopyableId value={r?.operatorId} />} />
      <TextField source="username" label="Username" />
      <TextField source="currencyCode" label="Currency" />
      <TextField source="country" label="Country" />
      <FunctionField label="Status" render={(r: { status?: string }) => <StatusChip value={r?.status} />} />
      <DateField source="createdAt" label="Created" showTime />
    </Datagrid>
  </List>
);
